import React from 'react';
import { ThemeContextProvider } from '../../../context';

export const Theme = ({ theme, children }) => (
  <ThemeContextProvider value={{ theme }}>
    {children}
  </ThemeContextProvider>
);
